import { type StoreAssistant } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { isCreateSurface } from './isCreateSurface';

/**
 * History arrives already folded by the backend (`A2UISurfaceFold.kt`): each surface's A2UI
 * messages sit on the row that created it. A row marked `a2ui_folded_into`, or one carrying
 * updates only, must not apply its A2UI again, so it is stripped; if that leaves the row with
 * no text and no actions it is dropped (undefined) rather than rendered as an empty bubble.
 */
export const foldA2UIHistoryRow = (row: StoreAssistant): StoreAssistant | undefined => {
	const a2uiMessages = row.agenticUiMessages ?? [];
	const isServerMarkedFolded =
		typeof row.content.message.message.message_metadata?.a2ui_folded_into === 'string';
	if (!isServerMarkedFolded && (a2uiMessages.length === 0 || a2uiMessages.some(isCreateSurface))) {
		return row;
	}

	const textContent = row.content.message.message.content;
	const hasContent = typeof textContent === 'string' ? textContent.trim().length > 0 : true;
	const hasActions = (row.content.message.message.actions?.length ?? 0) > 0;
	if (!hasContent && !hasActions) {
		return undefined;
	}

	const { agenticUiMessages: _ignored, ...rest } = row;
	return rest;
};
